import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { GlobalBannerService } from '../shared/components/global-banner/global-banner.service';
import { IState } from './purchase-order-data.reducer';
import { DocumentDataDispatcher } from '../document-data/document-data.dispatcher';
import { PurchaseOrder } from './purchase-order.model';
import { PurchaseOrderDataStore } from './purchase-order-data.store';
import { PurchaseOrderDataBuilder } from './purchase-order-data.builder';
import { SettingsDataStore } from '../settings-data/settings-data.store';

@Injectable()
export class PurchaseOrderDataDispatcher extends DocumentDataDispatcher<
  IState,
  PurchaseOrder
> {
  constructor(
    store: Store<any>,
    purchaseOrderDataStore: PurchaseOrderDataStore,
    settingsDataStore: SettingsDataStore,
    purchaseOrderDataBuilder: PurchaseOrderDataBuilder,
    globalBannerService: GlobalBannerService,
    translateService: TranslateService
  ) {
    super(
      store,
      purchaseOrderDataStore,
      settingsDataStore,
      purchaseOrderDataBuilder,
      globalBannerService,
      translateService
    );
  }
}
